import { useState, type Ref } from "react";
import { useTranslation } from "react-i18next";

import { useDeleteAccount, useGetProfileSuspense } from "@/api/bale";
import { Button } from "@/components/Button";
import { CardSubtitleHeader, CardTextContent } from "@/components/Card";
import { Dialog } from "@/components/Dialog";
import { FormField } from "@/components/FormField";
import { Input } from "@/components/Input";

export function DeleteAccountModal({ ref, onClose }: { ref: Ref<HTMLDialogElement>; onClose?: () => void }) {
  const { t } = useTranslation();
  const [username, setUsername] = useState("");
  const me = useGetProfileSuspense("@me", { query: { select: (data) => data.data.profile } });
  const deleteAccount = useDeleteAccount({ mutation: { onSuccess: () => window.location.reload() } });

  return (
    <Dialog ref={ref} onClose={onClose} closeOnOutside className="w-lg">
      <CardSubtitleHeader>{t("delete-account")}</CardSubtitleHeader>
      <CardTextContent className="flex flex-col gap-4">
        <div className="flex flex-col">
          <p className="px-4 font-disinterest">{t("delete-account-warning", { username: me.data.id })}</p>
        </div>
        <FormField title={t("username")}>
          <Input
            type="text"
            required
            placeholder={t("username")}
            name="username"
            onChange={(event) => setUsername(event.currentTarget.value)}
          />
        </FormField>
        <Button
          type="button"
          attention="danger"
          onClick={() => deleteAccount.mutate()}
          disabled={username !== me.data.id}
        >
          {t("delete-account-forever")}
        </Button>
      </CardTextContent>
    </Dialog>
  );
}
